import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startScheduledPageRefresh } from '../services/scheduledPageRefresh';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => startScheduledPageRefresh(), []);

  return null;
}
